// extracted by mini-css-extract-plugin
module.exports = {"seoOnly":"Main_seoOnly__5D1rS"};